// extracted by mini-css-extract-plugin
export default {"FAQlink":"FAQLink_FAQlink__CmV+h"};